import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-950 text-white mx-4 mb-4 rounded-3xl overflow-hidden">
      <div className="max-w-7xl mx-auto px-8 md:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src="/icon.png" alt="Aurays Logo" className="h-7 w-auto" />
              <span className="text-lg font-semibold tracking-tight">Aurays</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              The first online-to-offline dating app in Hong Kong. Meet naturally. Connect deeply. Date for real.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://www.instagram.com/Aurays.App"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C8B6FF]/30 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              {/* <a href="#" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C8B6FF]/30 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-base"></i>
              </a>
              <a href="#" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C8B6FF]/30 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-base"></i>
              </a> */}
            </div>
          </div>

          {/* Links */}
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-4">Navigate</p>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                About Us
              </Link>
              <Link to="/events" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Events
              </Link>
              <Link
                to="/love-aura-test"
                className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Love Aura Test
              </Link>
              <Link to="/register" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Join Early Access
              </Link>
              <a href="#faq" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                FAQ
              </a>
              <Link
                to="/privacy-policy"
                className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-and-conditions"
                className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Terms and Conditions
              </Link>
              <Link
                to="/community-guidelines"
                className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Community Guidelines
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-4">Stay Connected</p>
            <p className="text-sm text-gray-400 mb-2">Follow us for updates &amp; skip the queue</p>
            <p className="text-sm text-[#C8B6FF] font-medium">@Aurays.App</p>
            <p className="text-sm text-gray-400 mt-4">Hong Kong</p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-600">&copy; {new Date().getFullYear()} Aurays. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy-policy"
              className="text-xs text-gray-600 hover:text-gray-400 transition-colors cursor-pointer"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="text-xs text-gray-600 hover:text-gray-400 transition-colors cursor-pointer"
            >
              Terms of Service
            </Link>
            <Link
              to="/community-guidelines"
              className="text-xs text-gray-600 hover:text-gray-400 transition-colors cursor-pointer"
            >
              Community Guidelines
            </Link>
          </div>
        </div>
        <div className="mt-3 text-center">
          <p className="text-[11px] text-gray-600">
            This site is protected by reCAPTCHA and the Google{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="nofollow noreferrer"
              className="underline underline-offset-2 hover:text-gray-400"
            >
              Privacy Policy
            </a>{" "}
            and{" "}
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="nofollow noreferrer"
              className="underline underline-offset-2 hover:text-gray-400"
            >
              Terms of Service
            </a>{" "}
            apply.
          </p>
        </div>
      </div>
    </footer>
  );
}
